module.exports = __webpack_public_path__ + "static/media/cwiczenia-ortograficzne-online-ws2.a42d5b99.png";